export const APP_NAME = 'Candidate Terminal';
export const APP_MARK = 'CT';
export const APP_TAGLINE = 'Assessment Training Desk';
